export default {
  UNMATCHED: 0,
  UNRESOLVED: 1,
};



// WEBPACK FOOTER //
// ./src/modules/FAQ/_data/learningType.js